export default __webpack_public_path__ + "static/media/avatar_ig_daily.ae59d4c7.png";